<script>
export default {
  name: 'SendLocationModal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close', 'send'],
  data() {
    return {
      latitude: '',
      longitude: '',
      name: '',
      hasError: false,
    };
  },
  computed: {
    isValid() {
      return (
        this.isValidCoordinate(this.latitude) &&
        this.isValidCoordinate(this.longitude)
      );
    },
  },
  methods: {
    isValidCoordinate(value) {
      if (!value || !value.trim()) return false;
      const num = Number(value);
      return !Number.isNaN(num) && Number.isFinite(num);
    },
    onClose() {
      this.resetForm();
      this.$emit('close');
    },
    resetForm() {
      this.latitude = '';
      this.longitude = '';
      this.name = '';
      this.hasError = false;
    },
    send() {
      if (!this.isValid) {
        this.hasError = true;
        return;
      }
      this.$emit('send', {
        type: 'location',
        latitude: this.latitude.trim(),
        longitude: this.longitude.trim(),
        name: this.name.trim() || undefined,
      });
      this.onClose();
    },
  },
};
</script>

<template>
  <woot-modal :show="show" :on-close="onClose">
    <div class="flex flex-col p-6">
      <h3 class="text-lg font-semibold text-n-slate-12 mb-4">
        {{ $t('CONVERSATION.DINASTIA_ACTIONS.SEND_LOCATION') }}
      </h3>

      <div class="flex flex-col gap-4">
        <div>
          <label class="block text-sm font-medium text-n-slate-11 mb-1">
            {{ $t('CONVERSATION.DINASTIA_ACTIONS.LATITUDE') }} *
          </label>
          <input
            v-model="latitude"
            type="text"
            class="w-full border border-n-weak rounded-lg px-3 py-2 text-sm text-n-slate-12 bg-white dark:bg-n-solid-2 focus:ring-2 focus:ring-woot-500 focus:border-woot-500"
            :placeholder="
              $t('CONVERSATION.DINASTIA_ACTIONS.LATITUDE_PLACEHOLDER')
            "
          />
        </div>

        <div>
          <label class="block text-sm font-medium text-n-slate-11 mb-1">
            {{ $t('CONVERSATION.DINASTIA_ACTIONS.LONGITUDE') }} *
          </label>
          <input
            v-model="longitude"
            type="text"
            class="w-full border border-n-weak rounded-lg px-3 py-2 text-sm text-n-slate-12 bg-white dark:bg-n-solid-2 focus:ring-2 focus:ring-woot-500 focus:border-woot-500"
            :placeholder="
              $t('CONVERSATION.DINASTIA_ACTIONS.LONGITUDE_PLACEHOLDER')
            "
          />
        </div>

        <div>
          <label class="block text-sm font-medium text-n-slate-11 mb-1">
            {{ $t('CONVERSATION.DINASTIA_ACTIONS.PLACE_NAME') }}
          </label>
          <input
            v-model="name"
            type="text"
            class="w-full border border-n-weak rounded-lg px-3 py-2 text-sm text-n-slate-12 bg-white dark:bg-n-solid-2 focus:ring-2 focus:ring-woot-500 focus:border-woot-500"
          />
        </div>

        <p v-if="hasError" class="text-sm text-n-ruby-11">
          {{ $t('CONVERSATION.DINASTIA_ACTIONS.INVALID_COORDINATES') }}
        </p>
      </div>

      <div class="flex justify-end gap-2 mt-6">
        <woot-button variant="clear" @click="onClose">
          {{ $t('CANCEL') }}
        </woot-button>
        <woot-button :disabled="!isValid" @click="send">
          {{ $t('CONVERSATION.DINASTIA_ACTIONS.SEND_LOCATION') }}
        </woot-button>
      </div>
    </div>
  </woot-modal>
</template>
